import React from "react";

import Svg from "@/styles/Svg";

import * as Styled from "./styles";

export type PrimaryButtonProps = {
  onClick: () => void;
  label: string;
  disabled: boolean;
  dataQA?: string;
};

export const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  onClick,
  disabled = false,
  label,
  dataQA,
}: PrimaryButtonProps): JSX.Element => {
  return (
    <Styled.PrimaryButton
      onClick={onClick}
      disabled={disabled}
      data-qa={dataQA}
    >
      {label}
    </Styled.PrimaryButton>
  );
};

export default PrimaryButton;

export type GhostButtonProps = PrimaryButtonProps & {
  icon?: string;
  iconPosition?: "left" | "right";
};

export const GhostButton: React.FC<GhostButtonProps> = ({
  onClick,
  disabled = false,
  label,
  icon,
  dataQA,
  iconPosition = "right",
}: GhostButtonProps): JSX.Element => {
  return (
    <Styled.GhostButton onClick={onClick} disabled={disabled} data-qa={dataQA}>
      {icon && iconPosition === "left" && (
        <Styled.IconWrapper iconPosition={iconPosition}>
          <Svg contents={icon} height={12} width={12} />
        </Styled.IconWrapper>
      )}
      {label}
      {icon && iconPosition === "right" && (
        <Styled.IconWrapper iconPosition={iconPosition}>
          <Svg contents={icon} height={12} width={12} />
        </Styled.IconWrapper>
      )}
    </Styled.GhostButton>
  );
};
